:host {
    --uui-page-container-max-width: var(--uui-page-width-large);
    --uui-page-container-margin: auto;
}

:host div {
    max-width: var(--uui-page-container-max-width);
    margin-left: var(--uui-page-container-margin);
    margin-right: var(--uui-page-container-margin);
}

@media (max-width: 1280px) {
    :host {
        --uui-page-container-max-width: var(--uui-page-width-medium);
        --uui-page-container-margin: var(--uui-large-spacing);
    }
}